import Swal from "sweetalert2";
import i18n from "i18next"; // or wherever your i18n instance is imported from

const t = (fa, en) => (i18n.language === "fa" ? fa : en);

export const Confirm = (
  title = t("حذف ", "Delete "),
  text = t("آیا از حذف  اطمینان دارید ؟", "Are you sure you want to delete ?"),
  icon
) => {
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: t("تایید", "Confirm"),
    cancelButtonText: t("لغو", "Cancel"),
  });
};

export const Alert = (
  title = t("خطا", "Error"),
  text = t("خطایی رخ داده است", "An error has occurred"),
  icon = "error"
) => {
  return Swal.fire({
    title,
    text,
    icon,
    confirmButtonText: t("تایید", "Confirm"),
    cancelButtonText: t("لغو", "Cancel"),
  });
};
